import { HttpClient, HttpEvent } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppService } from '../../app.service';
import { DropdownOption } from '../../interfaces/dropdown-option.interface';

@Injectable({
    providedIn: 'root',
})
export class CreditorService {
    private _creditorPortalApiUrl: string = '';

    public constructor(
        public appService: AppService,
        public http: HttpClient,
        @Inject('CREDITORPORTAL_API_BASE_URL') creditorPortalApiUrl: string,
    ) {
        this._creditorPortalApiUrl = creditorPortalApiUrl;
    }

    public getIndustryTypes = (): Observable<HttpEvent<DropdownOption[]>> => {
        let result: BehaviorSubject<any> = new BehaviorSubject<
            DropdownOption[]
        >([]);
        const apipath: string = 'Creditor/industry-types';
        const fullPath: string = this._creditorPortalApiUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<DropdownOption[]>(fullPath, options);
    };

    public getPaymentTypes = (): Observable<HttpEvent<DropdownOption[]>> => {
        let result: BehaviorSubject<any> = new BehaviorSubject<
            DropdownOption[]
        >([]);
        const apipath: string = 'Creditor/payment-types';
        const fullPath: string = this._creditorPortalApiUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<DropdownOption[]>(fullPath, options);
    };

    public getAllCreditors = (): Observable<any> => {
        let result: BehaviorSubject<any> = new BehaviorSubject<any[]>([]);
        const apipath: string = 'Creditor/all';
        const fullPath: string = this._creditorPortalApiUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any[]>(fullPath, options);
    };

    public insertCreditor = (creditor: any): Observable<HttpEvent<number>> => {
        let result: BehaviorSubject<number> = new BehaviorSubject<number>(0);
        const apiPath: string = 'Creditor/insert';
        const fullPath: string = this._creditorPortalApiUrl + apiPath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.post<number>(fullPath, creditor, options);
    };

    public editCreditor = (creditor: any): Observable<HttpEvent<number>> => {
        let result: BehaviorSubject<number> = new BehaviorSubject<number>(0);
        const apiPath: string = 'Creditor/edit';
        const fullPath: string = this._creditorPortalApiUrl + apiPath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.put<any>(fullPath, creditor, options);
    };
}
